<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .smallData .m-form__group:first-child {
        padding-top: 40px !important;
    }

    .bloggerLabel {
      display: block;
      margin: 0 0 -40px 0;
    }

    hr {
      margin: 40px 0;
    }
    .cropBtn {
      display: block;
      width: 100%;
      border-top-right-radius: 0;
      border-top-left-radius: 0;
    }
    .bloggers .img-fluid {
      margin: 10px 0 0 0;
      width: 90px;
      height: 90px;
      border-radius: 45px;
    }
</style>

<template>
  <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
    <div class="m-portlet__body">
      <div class="row smallData">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('title')}">
            <label>
            {{$t('Cím')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.title">
            <div class="form-control-feedback">
              <span v-for="message in filter('title')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('url')}">
            <label>
            {{$t('URL')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.url">
            <div class="form-control-feedback">
              <span v-for="message in filter('url')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('author_id')}">
            <label>
            {{$t('Szerző')}}
            </label>
            <select class="form-control" v-model="model.author_id" v-if="model && model.selectables">
              <option :value="null">{{$t('Please choose')}}</option>
              <option v-for="item in model.selectables.authors" v-bind:key="item.id" :value="item.id">{{item.name}}</option>
            </select>
            <div class="form-control-feedback">
              <span v-for="message in filter('author_id')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('publisher')}">
            <label>
            {{$t('Kiadó')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.publisher">
            <div class="form-control-feedback">
              <span v-for="message in filter('publisher')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row smallData">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('pageNumber')}">
            <label>
            {{$t('Oldalszám')}}
            </label>
            <input type="number" class="form-control m-input" v-model="model.pageNumber">
            <div class="form-control-feedback">
              <span v-for="message in filter('pageNumber')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('price')}">
            <label>
            {{$t('Ár')}}
            </label>
            <div class="input-group">
              <input type="text" class="form-control m-input" v-model="model.price">
              <div class="input-group-addon">
                <span class="input-group-text">Ft</span>
              </div>
            </div>
            <div class="form-control-feedback">
              <span v-for="message in filter('price')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('externalPrice')}">
            <label>
            {{$t('Külső ár')}}
            </label>
            <div class="input-group">
              <input type="text" class="form-control m-input" v-model="model.externalPrice">
              <div class="input-group-addon">
                <span class="input-group-text">Ft</span>
              </div>
            </div>
            <div class="form-control-feedback">
              <span v-for="message in filter('externalPrice')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('externalLink')}">
            <label>
            {{$t('Külső link')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.externalLink">
            <div class="form-control-feedback">
              <span v-for="message in filter('externalLink')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row smallData">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('youtubeUrl')}">
            <label>
            {{$t('Youtube embed kód')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.youtubeUrl">
            <div class="form-control-feedback">
              <span v-for="message in filter('youtubeUrl')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('isbn')}">
            <label>
            {{$t('ISBN')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.isbn">
            <div class="form-control-feedback">
              <span v-for="message in filter('isbn')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('sku')}">
            <label>
            {{$t('Árukód')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.sku">
            <div class="form-control-feedback">
              <span v-for="message in filter('sku')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('language')}">
            <label>
            {{$t('Nyelv')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.language">
            <div class="form-control-feedback">
              <span v-for="message in filter('language')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row smallData">
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('publish_date')}">
            <label>
            {{$t('Kiadás dátuma')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.publish_date">
            <div class="form-control-feedback">
              <span v-for="message in filter('publish_date')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('cover')}">
            <label>
            {{$t('Borító')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.cover">
            <div class="form-control-feedback">
              <span v-for="message in filter('cover')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('maxQuantity')}">
            <label>
            {{$t('Maximális darabszám')}}
            </label>
            <div class="input-group">
              <input type="text" class="form-control m-input" v-model="model.maxQuantity">
              <div class="input-group-addon">
                <span class="input-group-text">db</span>
              </div>
            </div>
            <div class="form-control-feedback">
              <span v-for="message in filter('maxQuantity')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('imgUrl')}">
            <label>
            {{$t('Könyv kép')}}
            </label>
            <input type="file" accept="image/*" class="form-control m-input" id="file1" ref="file1" name="uploadFile1" @change="handleUpload('file1')" />
            <img class="img-fluid" v-if="model.imgUrl !== null" :src="model.imgUrl_url" />
            <div class="form-control-feedback">
              <span v-for="message in filter('imgUrl')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('pdfUrl')}">
            <label>
            {{$t('Első oldalak (PDF)')}}
            </label>
            <input type="file" accept="application/pdf" class="form-control m-input" id="file2" ref="file2" name="uploadFile1" @change="handleUpload('file2')" />
            <a v-if="model.pdfUrl !== null" :href="model.pdfUrl_url" target="_blank">{{$t('Megnyitás')}}</a>
            <div class="form-control-feedback">
              <span v-for="message in filter('pdfUrl')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class='form-group m-form__group'>
            <label>
            {{$t('Kategóriák')}}:
            </label>
            <div class='m-checkbox-list'>
              <label class='m-checkbox' v-for='(value, key) in model.selectables.categories'
                v-bind:key='key'>
              <input type='checkbox' :id="value.id" :value='value.id' v-model="model.category">
              {{value.name}}
              <span></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('title_line')}">
            <label>
            {{$t('Címsor')}}
            </label>
            <textarea class="form-control m-input" rows="1" maxlength="60" v-model="model.title_line"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('title_line')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('description')}">
            <label>
            {{$t('Leírás')}}
            </label>
            <textarea class="form-control m-input" rows="3" maxlength="300" v-model="model.description"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('description')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('sidenote_title')}">
            <label>
            {{$t('Fülszöveg cím')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.sidenote_title">
            <div class="form-control-feedback">
              <span v-for="message in filter('sidenote_title')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('sidenote')}">
            <label>
            {{$t('Fülszöveg')}}
            </label>
            <textarea class="form-control m-input" rows="12" v-model="model.sidenote"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('sidenote')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row bloggers">
        <div class="col-sm-4">
          <div class="form-group m-form__group"><label class="bloggerLabel">Blogger 1</label></div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger1_img')}">
            <label>
            {{$t('Kép')}}
            </label>
            <input type="file" accept="image/*" class="form-control m-input" id="blogger1_img" ref="blogger1_img" name="uploadFile1" @change="setImage1($event)" />
            <div v-if="file1 != null" style="width: 100%; height:auto; margin-bottom: 20px;">
              <vue-cropper
                ref='cropper1'
                :guides="false"
                :view-mode="2"
                drag-mode="crop"
                :aspect-ratio="1"
                :auto-crop-area="0.5"
                :min-container-width="250"
                :min-container-height="180"
                :src="imgSrc1"
                :ready="cropImage1"
                :cropend="cropImage1"
                :zoomable="false"
                alt="Kép"
                :img-style="{ 'width': '100%', 'height': 'auto' }">
              </vue-cropper>
              <button type="button" class="btn btn-primary cropBtn" @click="uploadImage1">Kép vágása</button>
            </div>
            <img class="img-fluid" v-if="model.blogger1_img_url !== null" :src="model.blogger1_img_url" />
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger1_img')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger1_name')}">
            <label>
            {{$t('Név')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.blogger1_name">
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger1_name')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger1_text')}">
            <label>
            {{$t('Vélemény')}}
            </label>
            <textarea class="form-control m-input" rows="2" maxlength="60" v-model="model.blogger1_text"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger1_text')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger1_link')}">
            <label>
            {{$t('Link')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.blogger1_link">
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger1_link')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group m-form__group"><label class="bloggerLabel">Blogger 2</label></div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger2_img')}">
            <label>
            {{$t('Kép')}}
            </label>
            <input type="file" accept="image/*" class="form-control m-input" id="blogger2_img" ref="blogger2_img" name="uploadFile1" @change="setImage2($event)" />
            <div v-if="file2 != null" style="width: 100%; height:auto; margin-bottom: 20px;">
              <vue-cropper
                ref='cropper2'
                :guides="false"
                :view-mode="2"
                drag-mode="crop"
                :aspect-ratio="1"
                :auto-crop-area="0.5"
                :min-container-width="250"
                :min-container-height="180"
                :src="imgSrc2"
                :ready="cropImage2"
                :cropend="cropImage2"
                :zoomable="false"
                alt="Kép"
                :img-style="{ 'width': '100%', 'height': 'auto' }">
              </vue-cropper>
              <button type="button" class="btn btn-primary cropBtn" @click="uploadImage2">Kép vágása</button>
            </div>
            <img class="img-fluid" v-if="model.blogger2_img_url !== null" :src="model.blogger2_img_url" />
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger2_img')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger2_name')}">
            <label>
            {{$t('Név')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.blogger2_name">
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger2_name')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger2_text')}">
            <label>
            {{$t('Vélemény')}}
            </label>
            <textarea class="form-control m-input" rows="2" maxlength="60" v-model="model.blogger2_text"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger2_text')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger2_link')}">
            <label>
            {{$t('Link')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.blogger2_link">
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger2_link')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group m-form__group"><label class="bloggerLabel">Blogger 3</label></div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger3_img')}">
            <label>
            {{$t('Kép')}}
            </label>
            <input type="file" accept="image/*" class="form-control m-input" id="blogger3_img" ref="blogger3_img" name="uploadFile1" @change="setImage3($event)" />
            <div v-if="file3 != null" style="width: 100%; height:auto; margin-bottom: 20px;">
              <vue-cropper
                ref='cropper3'
                :guides="false"
                :view-mode="2"
                drag-mode="crop"
                :aspect-ratio="1"
                :auto-crop-area="0.5"
                :min-container-width="250"
                :min-container-height="180"
                :src="imgSrc3"
                :ready="cropImage3"
                :cropend="cropImage3"
                :zoomable="false"
                alt="Kép"
                :img-style="{ 'width': '100%', 'height': 'auto' }">
              </vue-cropper>
              <button type="button" class="btn btn-primary cropBtn" @click="uploadImage3">Kép vágása</button>
            </div>
            <img class="img-fluid" v-if="model.blogger3_img_url !== null" :src="model.blogger3_img_url" />
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger3_img')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger3_name')}">
            <label>
            {{$t('Név')}}
            </label>
            <input type="text" class="form-control m-input" v-model="model.blogger3_name">
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger3_name')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger3_text')}">
            <label>
            {{$t('Vélemény')}}
            </label>
            <textarea class="form-control m-input" rows="2" maxlength="60" v-model="model.blogger3_text"></textarea>
            <div class="form-control-feedback">
              <span v-for="message in filter('blogger3_text')" v-bind:key="message">
              {{message}} <br/>
              </span>
            </div>
          </div>
          <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('blogger3_link')}">
                <label>
                {{$t('Link')}}
                </label>
                <input type="text" class="form-control m-input" v-model="model.blogger3_link">
                <div class="form-control-feedback">
                  <span v-for="message in filter('blogger3_link')" v-bind:key="message">
                  {{message}} <br/>
                  </span>
                </div>
              </div>
        </div>
      </div>
      <p>&nbsp;</p>
    </div>
    <Buttons v-on:save="save" :list-link="`/admin/designs/index`"></Buttons>
  </form>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import Buttons from '../../core/form/Buttons'
export default {
  name: 'BookForm',
  components: {vueCropper: VueCropper, Buttons},
  props: {
    model: {
      type: Object,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  data () {
    return {
      image: null,
      file1: null,
      file2: null,
      file3: null,
      imgSrc1: '',
      imgSrc2: '',
      imgSrc3: '',
      cropImg1: '',
      cropImg2: '',
      cropImg3: ''
    }
  },
  watch: {
    model: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
        if (val && val.url !== undefined && val.url !== null) {
          this.model.url = this.model.url.toLowerCase()
          if (val.url.startsWith('/') === false) {
            this.model.url = '/' + this.model.url
          }
          this.model.url = this.model.url.replace(' ', '-')
        }
      },
      deep: true
    }
  },
  methods: {
    setImage1 (event) {
      this.file1 = event.target.files[0]
      if (!this.file1.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc1 = event.target.result
          this.$refs.cropper1.replace(event.target.result)
        }
        reader.readAsDataURL(this.file1)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cropImage1 () {
      this.cropImg = this.$refs.cropper1.getCroppedCanvas().toDataURL()
      let cropImgUrl = "url('" + this.cropImg + "')"
      this.model.picUrl1 = cropImgUrl
    },
    uploadImage1 () {
      this.$http
        .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl1}, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          this.model.blogger1_img = res.data.data.path
          this.model.blogger1_img_url = res.data.data.uri
          this.file1 = null
          window.$('#blogger1_img').val(null)
        }).catch(res => {
        })
    },
    setImage2 (event) {
      this.file2 = event.target.files[0]
      if (!this.file2.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc2 = event.target.result
          this.$refs.cropper2.replace(event.target.result)
        }
        reader.readAsDataURL(this.file2)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cropImage2 () {
      this.cropImg = this.$refs.cropper2.getCroppedCanvas().toDataURL()
      let cropImgUrl = "url('" + this.cropImg + "')"
      this.model.picUrl2 = cropImgUrl
    },
    uploadImage2 () {
      this.$http
        .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl2}, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          this.model.blogger2_img = res.data.data.path
          this.model.blogger2_img_url = res.data.data.uri
          this.file2 = null
          window.$('#blogger2_img').val(null)
        }).catch(res => {
        })
    },
    setImage3 (event) {
      this.file3 = event.target.files[0]
      if (!this.file3.type.includes('image/')) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc3 = event.target.result
          this.$refs.cropper3.replace(event.target.result)
        }
        reader.readAsDataURL(this.file3)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    cropImage3 () {
      this.cropImg = this.$refs.cropper3.getCroppedCanvas().toDataURL()
      let cropImgUrl = "url('" + this.cropImg + "')"
      this.model.picUrl3 = cropImgUrl
    },
    uploadImage3 () {
      this.$http
        .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl3}, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          this.model.blogger3_img = res.data.data.path
          this.model.blogger3_img_url = res.data.data.uri
          this.file3 = null
          window.$('#blogger3_img').val(null)
        }).catch(res => {
        })
    },
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      /* if (this.imgSrc1 === '') {
        this.$store.commit('loading/changeUnsaved', false)
        this.$emit('save')
      } else {
        this.$http
          .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl1}, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.model.blogger1_img = res.data.data.path
            this.model.blogger1_img_url = res.data.data.uri
            this.file = null
            window.$('#blogger1_img').val(null)
            // this.$store.commit('loading/changeUnsaved', false)
            // this.$emit('save')
          }).catch(res => {
          })
      }
      if (this.imgSrc2 === '') {
        this.$store.commit('loading/changeUnsaved', false)
        this.$emit('save')
      } else {
        this.$http
          .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl2}, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.model.blogger2_img = res.data.data.path
            this.model.blogger2_img_url = res.data.data.uri
            this.file = null
            window.$('#blogger2_img').val(null)
            // this.$store.commit('loading/changeUnsaved', false)
            // this.$emit('save')
          }).catch(res => {
          })
      }
      if (this.imgSrc3 === '') {
        this.$store.commit('loading/changeUnsaved', false)
        this.$emit('save')
      } else {
        this.$http
          .post(process.env.API_URL + '/api/v1/admin/settings/upload-base64', {image: this.model.picUrl3}, {
            'headers': {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
              'language': this.$store.state.loading.language
            }
          }).then(res => {
            this.model.blogger3_img = res.data.data.path
            this.model.blogger3_img_url = res.data.data.uri
            this.file = null
            window.$('#blogger3_img').val(null)
            // this.$store.commit('loading/changeUnsaved', false)
            // this.$emit('save')
          }).catch(res => {
          })
      } */
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    },
    handleUpload (ref) {
      this.file = this.$refs[ref].files[0]
      this.errors = {}
      if (this.file === '' || this.file === null) {
        this.errors['file'] = []
        this.errors.item_file_name.push(this.$translate.t('Fájl megadása kötelező!'))
      }

      if (JSON.stringify(this.errors) !== JSON.stringify({})) {
        this.$forceUpdate()
        return false
      }

      let formData = new FormData()
      formData.append('file', this.file)
      let self = this
      this.$http
        .post(process.env.API_URL + '/api/v1/admin/settings/upload-file', formData, {
          'headers': {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (ref === 'file1') {
            self.model.imgUrl = res.data.data.path
            self.model.imgUrl_url = res.data.data.uri
          }
          if (ref === 'file2') {
            self.model.pdfUrl = res.data.data.path
            self.model.pdfUrl_url = res.data.data.uri
          }
          if (ref === 'blogger1_img') {
            self.model.blogger1_img = res.data.data.path
            self.model.blogger1_img_url = res.data.data.uri
          }
          if (ref === 'blogger2_img') {
            self.model.blogger2_img = res.data.data.path
            self.model.blogger2_img_url = res.data.data.uri
          }
          if (ref === 'blogger3_img') {
            self.model.blogger3_img = res.data.data.path
            self.model.blogger3_img_url = res.data.data.uri
          }
          self.file = null
          window.$('#file').val(null)
        }).catch(res => {

        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/book/BookForm.vue